import GoBackPaywallButton from 'components/common/GoBackPaywallButton/GoBackPaywallButton'
import { PaywallDisplay } from 'redux/slices/paywall'
import React from 'react'
import { useStyles } from './styles'

interface PaywallContainerProps {
    children: React.ReactNode
    goBackStep?: PaywallDisplay
    onGoBack?: Function
    className?: string
    disableBackStep?: boolean
}

export const PaywallContainer: React.FC<PaywallContainerProps> = ({ children, goBackStep, className, onGoBack }) => {
    const classes = useStyles()
    return (
        <div className={classes.paywallContainer}>
            {goBackStep && <GoBackPaywallButton step={goBackStep} onGoBack={onGoBack} />}
            <div className={className}>{children}</div>
        </div>
    )
}

export default React.memo(PaywallContainer)
